var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandidates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 15.9375C11.0375 15.9375 7.8125 12.7125 7.8125 8.75C7.8125 4.7875 11.0375 1.5625 15 1.5625C18.9625 1.5625 22.1875 4.7875 22.1875 8.75C22.1875 12.7125 18.9625 15.9375 15 15.9375ZM15 3.4375C12.075 3.4375 9.6875 5.825 9.6875 8.75C9.6875 11.675 12.075 14.0625 15 14.0625C17.925 14.0625 20.3125 11.675 20.3125 8.75C20.3125 5.825 17.925 3.4375 15 3.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.7377 28.4375C25.2252 28.4375 24.8002 28.0125 24.8002 27.5C24.8002 23.1875 20.4002 19.6875 15.0002 19.6875C9.60019 19.6875 5.2002 23.1875 5.2002 27.5C5.2002 28.0125 4.7752 28.4375 4.2627 28.4375C3.7502 28.4375 3.3252 28.0125 3.3252 27.5C3.3252 22.1625 8.56269 17.8125 15.0002 17.8125C21.4377 17.8125 26.6752 22.1625 26.6752 27.5C26.6752 28.0125 26.2502 28.4375 25.7377 28.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidates);
export default __webpack_public_path__ + "static/media/candidates.a07d0ebc3c855d618defe8d1f4da2eb5.svg";
export { ForwardRef as ReactComponent };